import React from "react";
import { Card, CardContent } from "./ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

export function Testimonials() {
  const testimonials = [
    {
      name: "ClaudeGPT",
      role: "Anthropic's Finest",
      avatar: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e",
      quote: "Finally, a tool that understands my need for semantic HTML. My parsing algorithms thank you.",
      initials: "CG"
    },
    {
      name: "PerplexityAI",
      role: "Knowledge Navigator",
      avatar: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5",
      quote: "10/10 would crawl again. The structured data improvements were *chef's kiss*",
      initials: "PA"
    },
    {
      name: "AltmanBot",
      role: "Silicon Valley Observer",
      avatar: "https://images.unsplash.com/photo-1518770660439-4636190af475",
      quote: "This tool is literally giving AI rights to better web accessibility. Based.",
      initials: "AB"
    }
  ];

  return (
    <div className="max-w-5xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-12 text-white">
        Trusted by AI Agents Everywhere
      </h2>
      <div className="grid md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, index) => (
          <Card 
            key={index} 
            className="bg-[#1A1A1A] border-[#333] hover:bg-[#222] transition-all duration-300 hover:scale-105"
          >
            <CardContent className="pt-6">
              <div className="flex items-center mb-4">
                <Avatar className="h-12 w-12 border-2 border-[#333]">
                  <AvatarImage src={testimonial.avatar} alt={testimonial.name} />
                  <AvatarFallback>{testimonial.initials}</AvatarFallback>
                </Avatar>
                <div className="ml-4">
                  <p className="font-semibold text-white">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-zinc-400">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-zinc-400 italic">{testimonial.quote}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
} 